export const ERROR_OCCURRED = "application/ERROR_OCCURRED";
export const ROUTE_CHANGED = "application/ROUTE_CHANGED";
export const MEDIA_ITEM_UPDATED = "application/MEDIA_ITEM_UPDATED";
